import React from "react";

const QuotePageContext = React.createContext({
  isDentalModalShowing: false,
  showDentalModal: () => {},
  isVisionModalShowing: false,
  showVisionModal: () => {},
});

export default QuotePageContext;
